/* globals $ */
'use strict';

$(function () {});
